import React from 'react';
import { FormattedMessage } from 'react-intl';

import SimpleFieldsPanel from 'components/configuration/dealer/Global/components/common/SimpleFieldsPanel';
import { useFieldConfig } from 'ui/layout/ReportIssue/components/ReportIssueContentConfig';

/**
 * @type {React.FC<{ disabled?: boolean }>}
 */
const ReportIssueContentForm = ({ disabled }) => {
  const REPORT_ISSUE_FIELDS = useFieldConfig(disabled);

  return (
    <form>
      <div>
        <FormattedMessage
          id="reportIssue.intro"
          defaultMessage="Fill out this form to report an issue or request support. We'll reach out soon to help you."
        />
      </div>
      <div className="d-flex flex-column gap-3 mt-4">
        <SimpleFieldsPanel nbColumn={1} config={REPORT_ISSUE_FIELDS} formFieldProps={{ validateOnInit: false }} />
      </div>
    </form>
  );
};

export default ReportIssueContentForm;
